import capsule from "@/constants/capsule";
import axios, { AxiosRequestConfig } from "axios";

// 创建 axios 实例
export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000, // 请求超时时间
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 从 localStorage 获取 token
    const token = localStorage.getItem("jwtToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response.data.data;
  },
  (error) => {
    if (error.response) {
      console.log(error.response.status, "error.response.status");
      switch (error.response.status) {
        case 401:
          // 未授权处理
          capsule.logout();
          localStorage.removeItem("jwtToken");
          window.location.href = "/login"; // 降级处理
          break;
        case 403:
          // 权限不足处理
          break;
        case 404:
          // 资源不存在处理
          break;
        case 500:
          // 服务器错误处理
          break;
      }
    }
    return Promise.reject(error.response);
  }
);

// 封装 GET 请求
export const get = <T>(
  url: string,
  params?: any,
  config?: AxiosRequestConfig
) => {
  return api.get<T, T>(url, { params, ...config });
};

// 封装 POST 请求
export const post = <T>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig
) => {
  return api.post<T, T>(url, data, config);
};

export const apiDelete = <T>(url: string, config?: AxiosRequestConfig) => {
  return api.delete<T, T>(url, config);
};
